<div class="modal-header" id="pch-duration-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION"></h3>
    <span class="close" (click)="closeModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="approvedPCHForm">
        <fieldset formArrayName="formChildren">
            <div class="row mb-3">
                <label
                    class="col-form-label text-start"
                    for="startDate"
                    translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_START_LABEL"
                ></label>
                <div class="col-lg-6 col-12">
                    <pace-core-date-input
                        id="startDate"
                        [(model)]="model.startDateTime"
                        [parentForm]="formChildren"
                        (valueChange)="model.setDateTimeOptions()"
                        [ariaLabel]="'NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_START_LABEL' | translate"
                    ></pace-core-date-input>
                </div>
                <div class="col-lg-6 col-12 mt-lg-0 mt-2">
                    <div class="d-flex align-items-center gap-2">
                        <div class="flex-grow-1 col-lg-12">
                            <pace-core-time-input
                                [(model)]="model.startDateTime"
                                [parentForm]="formChildren"
                                (valueChange)="model.setDateTimeOptions()"
                                [ariaLabel]="'NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_START_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <label
                    class="col-form-label text-start"
                    for="endDate"
                    translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_END_LABEL"
                ></label>
                <div class="col-lg-6 col-12">
                    <pace-core-date-input
                        id="endDate"
                        [(model)]="model.endDateTime"
                        (valueChange)="model.setDateTimeOptions()"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_END_LABEL' | translate"
                    ></pace-core-date-input>
                </div>
                <div class="col-lg-6 col-12 mt-lg-0 mt-2">
                    <div class="d-flex align-items-center gap-2">
                        <div class="flex-grow-1 col-lg-12">
                            <pace-core-time-input
                                [(model)]="model.endDateTime"
                                [parentForm]="formChildren"
                                [ariaLabel]="'NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_END_LABEL' | translate"
                            ></pace-core-time-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <label
                    class="col-form-label text-start"
                    for="customerApprover"
                    translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_CUSTOMER_APPROVER_LABEL"
                ></label>

                <div class="col-12">
                    <pace-core-text-input
                        id="customerApprover"
                        [(model)]="model.approver"
                        [parentForm]="formChildren"
                        [ariaLabel]="'NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_CUSTOMER_APPROVER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer justify-content-between justify-content-md-end">
    <button
        class="btn btn-secondary"
        type="button"
        (click)="closeModal()"
        translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_CANCEL_BUTTON_LABEL"
    ></button>
    <button
        class="btn btn-primary"
        type="submit"
        [disabled]="pchUpdateInProgress || approvedPCHForm.invalid"
        (click)="updatePCHDuration()"
        translate="NOTIFICATION_DETAILS_UPDATE_PCH_DURATION_SAVE_BUTTON_LABEL"
    ></button>
</div>
